import { RootState } from "../models";

export const selectPlayerId = (state: RootState) => {
  const playerId = state.data.isLoaded ? state.data.playerId : undefined;
  return playerId;
};
